import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SA_SM_PERSONAS, _DERIVED_SERVICE_ADVI, _DERIVED_TECHNICIAN_P, _CRM_PERSONAS;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _filter from 'lodash/filter';
import _flatMap from 'lodash/flatMap';
import _toLower from 'lodash/toLower';
import _uniq from 'lodash/uniq';
import _some from 'lodash/some';
import _find from 'lodash/find';
import _reduce from 'lodash/reduce';
import _isEmpty from 'lodash/isEmpty';
import _curry from 'lodash/curry';
import _isNil from 'lodash/isNil';
import _get from 'lodash/get';
import UserReader from '../readers/User';
import { getDefaultMainSiteId } from './site';
import { tget } from './general';
import TEnvReader from '../readers/Env';
import { USER_TYPES } from '../constants/users';
import { PERSONAS } from '../constants/personas';
import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING, NO_DATA } from '../app.constants';
export var SA_SM_PERSONAS = (_SA_SM_PERSONAS = {}, _defineProperty(_SA_SM_PERSONAS, _toLower(PERSONAS.SERVICE_ADVISOR), PERSONAS.SERVICE_ADVISOR), _defineProperty(_SA_SM_PERSONAS, _toLower(PERSONAS.SERVICE_MANAGER), PERSONAS.SERVICE_MANAGER), _defineProperty(_SA_SM_PERSONAS, _toLower(PERSONAS.SERVICE_DISPATCHER), PERSONAS.SERVICE_DISPATCHER), _SA_SM_PERSONAS);
export var DERIVED_SERVICE_ADVISOR_PERSONAS = (_DERIVED_SERVICE_ADVI = {}, _defineProperty(_DERIVED_SERVICE_ADVI, _toLower(PERSONAS.SERVICE_ADVISOR), PERSONAS.SERVICE_ADVISOR), _defineProperty(_DERIVED_SERVICE_ADVI, _toLower(PERSONAS.SERVICE_DISPATCHER), PERSONAS.SERVICE_DISPATCHER), _DERIVED_SERVICE_ADVI);
export var DERIVED_TECHNICIAN_PERSONAS = (_DERIVED_TECHNICIAN_P = {}, _defineProperty(_DERIVED_TECHNICIAN_P, _toLower(PERSONAS.TECHNICIAN), PERSONAS.TECHNICIAN), _defineProperty(_DERIVED_TECHNICIAN_P, _toLower(PERSONAS.SERVICE_DISPATCHER), PERSONAS.SERVICE_DISPATCHER), _DERIVED_TECHNICIAN_P);
export var CRM_PERSONAS = (_CRM_PERSONAS = {}, _defineProperty(_CRM_PERSONAS, _toLower(PERSONAS.SALES_PERSON), PERSONAS.SALES_PERSON), _defineProperty(_CRM_PERSONAS, _toLower(PERSONAS.SALES_MANAGER), PERSONAS.SALES_MANAGER), _defineProperty(_CRM_PERSONAS, _toLower(PERSONAS.BDC_SPECIALIST), PERSONAS.BDC_SPECIALIST), _CRM_PERSONAS);
export var SALES_PERSONAS = [PERSONAS.SALES_PERSON, PERSONAS.BACK_OFFICE_CLERK, PERSONAS.SALES_MANAGER, PERSONAS.F_nd_I_MANAGER, PERSONAS.CLOSING_MANAGER, PERSONAS.BDC_SPECIALIST, PERSONAS.BDC_MANAGER, PERSONAS.SALES_ADVISOR, PERSONAS.SALES_GREETER, PERSONAS.INVENTORY_MANAGER, PERSONAS.DISPATCHER, PERSONAS.CASHIER, PERSONAS.WARRANTY_CLERK];
export var getCDMSUser = function getCDMSUser(userList) {
  return _filter(userList, function (user) {
    return UserReader.type(user) === USER_TYPES.CDMS_USER;
  });
};
export var getActiveUsers = function getActiveUsers(userList) {
  return _filter(userList, function (user) {
    return UserReader.isActive(user);
  });
};
export var isUserAccessibleInCurrentSite = function isUserAccessibleInCurrentSite(user) {
  var loggedInUser = TEnvReader.userInfo();
  var dealerId = UserReader.dealerId(loggedInUser);
  var siteId = loggedInUser.tekSiteId || getDefaultMainSiteId();
  if (_isEmpty(UserReader.dealerOemSites(user))) return siteId === getDefaultMainSiteId();

  var _ref = _find(UserReader.dealerOemSites(user), ['dealerId', dealerId]) || EMPTY_OBJECT,
      oemSites = _ref.oemSites;

  var userSiteId = tget(_find(oemSites, ['siteId', siteId]), 'siteId', siteId);
  return siteId === userSiteId;
};
export var getDealerUsers = function getDealerUsers(allUsers, dealerId) {
  return _flatMap(allUsers, function (user) {
    var dealerAndRoles = UserReader.dealerAndRoles(user);

    var hasCurrentDealerRole = _some(dealerAndRoles, ['dealerId', dealerId]);

    return hasCurrentDealerRole ? user : EMPTY_ARRAY;
  });
};
export var getDealerUserPersonas = function getDealerUserPersonas(user, roleList) {
  var dealerRoles = UserReader.dealerAndRoles(user);
  if (roleList[UserReader.roleId(user)]) return [roleList[UserReader.roleId(user)].persona];
  return _uniq(_flatMap(dealerRoles, function (dealerRole) {
    var primaryRoleId = dealerRole.roleId,
        secondaryRoleIds = dealerRole.secondaryRoleIds;

    var secondaryPersonas = _flatMap(secondaryRoleIds, function (secondaryRoleId) {
      return roleList[secondaryRoleId] ? [roleList[secondaryRoleId].persona] : [];
    });

    return [].concat(_toConsumableArray(secondaryPersonas), _toConsumableArray(roleList[primaryRoleId] ? [roleList[primaryRoleId].persona] : []));
  }));
};
export var getDealerUserRoleIds = function getDealerUserRoleIds(user, roleList) {
  var dealerRoles = UserReader.dealerAndRoles(user);
  if (roleList[UserReader.roleId(user)]) return [UserReader.roleId(user)];
  return _uniq(_flatMap(dealerRoles, function (dealerRole) {
    var primaryRoleId = dealerRole.roleId,
        secondaryRoleIds = dealerRole.secondaryRoleIds;

    var secondaryRoleList = _flatMap(secondaryRoleIds, function (secondaryRoleId) {
      return roleList[secondaryRoleId] ? [secondaryRoleId] : [];
    });

    return [].concat(_toConsumableArray(secondaryRoleList), _toConsumableArray(roleList[primaryRoleId] ? [primaryRoleId] : []));
  }));
};
export var getPrimaryRoleNameForCurrentDealer = function getPrimaryRoleNameForCurrentDealer(user, dealerId, roleList) {
  if (_isNil(user)) return NO_DATA;
  var dealerAndRoles = UserReader.dealerAndRoles(user);

  var currentDealerRole = _find(dealerAndRoles, ['dealerId', dealerId]);

  if (_isNil(currentDealerRole)) return NO_DATA;
  var primaryRoleId = currentDealerRole.roleId;
  return _get(roleList[primaryRoleId], 'name', NO_DATA);
};
export var getLoggedInUserDealerId = function getLoggedInUserDealerId() {
  var loggedInUserInfo = TEnvReader.userInfo();
  var loggedInUserDealerId = UserReader.dealerId(loggedInUserInfo);
  return loggedInUserDealerId;
};
export var getDealerUserEmployeeDetails = function getDealerUserEmployeeDetails(user) {
  var dealerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_STRING;
  var loggedInUserDealerId = getLoggedInUserDealerId();
  var employeeDealerMaps = UserReader.employeeDealerMaps(user);
  var employeeDetailsForCurrentDealer = _find(employeeDealerMaps, {
    dealerId: dealerId || loggedInUserDealerId
  }) || EMPTY_OBJECT;
  return employeeDetailsForCurrentDealer;
};
export var checkIfPersonaExists = function checkIfPersonaExists(personaToCheck, roleList, user) {
  var personas = getDealerUserPersonas(user, roleList);
  return _some(personas, function (persona) {
    return personaToCheck[_toLower(persona)];
  });
};
export var isTechnicianByPersona = function isTechnicianByPersona(user, roleList) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT,
      personasToCheck = _ref2.personasToCheck;

  var personaToCheck = personasToCheck || DERIVED_TECHNICIAN_PERSONAS;
  return checkIfPersonaExists(personaToCheck, roleList, user);
};
export var isServiceAdvisorByPersona = function isServiceAdvisorByPersona(user, roleList) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT,
      personasToCheck = _ref3.personasToCheck;

  var personaToCheck = personasToCheck || DERIVED_SERVICE_ADVISOR_PERSONAS;
  return checkIfPersonaExists(personaToCheck, roleList, user);
};
export var isServiceDirectorByPersona = function isServiceDirectorByPersona(user, roleList) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT,
      personasToCheck = _ref4.personasToCheck;

  var personaToCheck = personasToCheck || _defineProperty({}, "".concat(_toLower(PERSONAS.SERVICE_DIRECTOR)), PERSONAS.SERVICE_DIRECTOR);

  return checkIfPersonaExists(personaToCheck, roleList, user);
};
export var isServiceManagerByPersona = function isServiceManagerByPersona(user, roleList) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT,
      personasToCheck = _ref6.personasToCheck;

  var personaToCheck = personasToCheck || _defineProperty({}, "".concat(_toLower(PERSONAS.SERVICE_MANAGER)), PERSONAS.SERVICE_MANAGER);

  return checkIfPersonaExists(personaToCheck, roleList, user);
};
export var isROCounterPersonByPersona = function isROCounterPersonByPersona(user, roleList) {
  var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT,
      personasToCheck = _ref8.personasToCheck;

  var personaToCheck = personasToCheck || _defineProperty({}, "".concat(_toLower(PERSONAS.RO_SALE_COUNTER_PERSON)), PERSONAS.RO_SALE_COUNTER_PERSON);

  return checkIfPersonaExists(personaToCheck, roleList, user);
};
export var isServiceDispatcherByPersona = function isServiceDispatcherByPersona(user, roleList) {
  var _ref10 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT,
      personasToCheck = _ref10.personasToCheck;

  var personaToCheck = personasToCheck || _defineProperty({}, "".concat(_toLower(PERSONAS.SERVICE_DISPATCHER)), PERSONAS.SERVICE_DISPATCHER);

  return checkIfPersonaExists(personaToCheck, roleList, user);
};
export var isTechnician = function isTechnician(roleId, roleList) {
  return roleList[roleId] && roleList[roleId].persona.toLowerCase() === PERSONAS.TECHNICIAN.toLowerCase();
};
export var isServiceAdvisor = function isServiceAdvisor(roleId, roleList) {
  return roleList[roleId] && roleList[roleId].persona.toLowerCase() === PERSONAS.SERVICE_ADVISOR.toLowerCase();
};
export var isServiceDirector = function isServiceDirector(roleId, roleList) {
  return roleList[roleId] && roleList[roleId].persona.toLowerCase() === PERSONAS.SERVICE_DIRECTOR.toLowerCase();
};
export var isServiceManager = function isServiceManager(roleId, roleList) {
  return roleList[roleId] && roleList[roleId].persona.toLowerCase() === PERSONAS.SERVICE_MANAGER.toLowerCase();
};
export var isROSaleCounterPerson = function isROSaleCounterPerson(roleId, roleList) {
  return roleList[roleId] && roleList[roleId].persona.toLowerCase() === PERSONAS.RO_SALE_COUNTER_PERSON.toLowerCase();
};
export var isInternalUser = function isInternalUser(user) {
  return UserReader.type(user) === USER_TYPES.INTERNAL_USER;
};
export var isServiceAdvisorProfile = _curry(function (roleList, user) {
  return checkIfPersonaExists(SA_SM_PERSONAS, roleList, user);
});
export var isUserActiveAndAccessibleInCurrentSite = function isUserActiveAndAccessibleInCurrentSite(user) {
  return UserReader.isActive(user) && isUserAccessibleInCurrentSite(user);
};
export var getAdvisors = function getAdvisors(users, roleList) {
  return _filter(users, isServiceAdvisorProfile(roleList));
};
export var getActiveAccessibleAdvisors = function getActiveAccessibleAdvisors(users, roleList) {
  return _filter(users, function (user) {
    return isServiceAdvisorProfile(roleList, user) && isUserActiveAndAccessibleInCurrentSite(user);
  });
};
export var getUserOptionsWithActive = function getUserOptionsWithActive(userList, roleList) {
  var isActive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : UserReader.active;
  return _reduce(userList, function (acc, user) {
    return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, user), {}, {
      value: UserReader.userId(user),
      label: UserReader.name(user),
      active: isActive(user, roleList)
    })]);
  }, EMPTY_ARRAY);
};
export var getLoggedInUserId = function getLoggedInUserId() {
  var loggedInUserInfo = TEnvReader.userInfo();
  var loggedInUserId = UserReader.id(loggedInUserInfo);
  return loggedInUserId;
};